import api from "@src/api/api";

export interface CartResponse {
  buyNowMode: boolean;
  cartId: string;
  vendors: Vendor[];
  current_page: number;
  total_pages: number;
}

interface Vendor {
  seller: Seller;
  items: CartItem[];
}

interface Seller {
  id: number;
  externalId: string;
  accountType: string;
  phoneNumber: string | null;
  avatarUrl: string | null;
  name: string;
  superSellerBadge: string | null;
  lastSeen: string | null;
}

export interface CartItem {
  id: string;
  name: string;
  offerId: number;
  price: Price;
  availableAmount: number;
  featuredImage: string;
  amount: number;
}

interface Price {
  value: number;
  currency: string;
  viewPattern: string;
  currencySymbol: string;
  exchanged: boolean;
  originalPrice: number | null;
  VAT: number;
}

export default async function cart(): Promise<CartResponse> {
  const baseUrl = import.meta.env.VITE_MARKETPLACE_API_URL;
  const { data } = await api.get(`${baseUrl}/cart`);
  return data;
}
